import { render, staticRenderFns } from "./BillingDashboard.vue?vue&type=template&id=5c83fdca&scoped=true&"
import script from "./BillingDashboard.vue?vue&type=script&lang=js&"
export * from "./BillingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83fdca",
  null
  
)

export default component.exports